import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Copy = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="copy icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M4 0C2.89543 0 2 0.895431 2 2V17C2 18.1046 2.89543 19 4 19H15C16.1046 19 17 18.1046 17 17V2C17 0.895431 16.1046 0 15 0H4Z"
    />
    <path
      className={pathClass}
      d="M7 22V21H17C18.1046 21 19 20.1046 19 19V5H20C21.1046 5 22 5.89543 22 7V22C22 23.1046 21.1046 24 20 24H9C7.89543 24 7 23.1046 7 22Z"
    />
  </svg>
)
